/**
 * Renders like `(XXX) XXX-1234.` — strips non-digits, masks all but the last four digit positions
 * (last segment is four chars, left-padded with X when fewer than four digits exist).
 */
export function formatMaskedPhoneNumberDisplay (raw) {
  const digits = String(raw ?? '').replace(/\D/g, '')

  if (!digits) {
    return '(XXX) XXX-'
  }

  const tail = digits.slice(-4)
  const lastSegment = tail.padStart(4, 'X')

  return `(XXX) XXX-${lastSegment}`
}

export async function callAPI (url, method, body, headers) {
  const response = await fetch(url, {
    method,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      ...headers
    }
  })

  if (!response.ok) {
    try {
      const responseData = await response.json()

      return responseData
    } catch (error) {
      const uknownErrorResponse = {
        message: 'Unknown error',
        isSuccess: false,
        data: {}
      }

      return uknownErrorResponse
    }
  }

  const responseData = await response.json()

  return responseData
}

export function getBrandId (brandConfig) {
  if (!brandConfig || !Array.isArray(brandConfig.brands)) {
    return undefined
  }

  const brandIdText = brandConfig.brands.find((brand) =>
    brand?.includes('brand')
  )

  if (brandIdText) {
    return brandIdText.split('brand')[1]
  }

  return undefined
}

export function getErrorMessage (errorMessages, responseMessage) {
  if (!Array.isArray(errorMessages) || !responseMessage) {
    return responseMessage
  }

  const targetErrorMsg = errorMessages.find((error) =>
    error?.props?.baseMessage?.toLowerCase() === responseMessage.toLowerCase()
  )

  return targetErrorMsg?.props?.altMessage || responseMessage
}
